(async () => {
    const { Core } = await importModule('Core');

    // Corrects every #product-stock-alert badge on the page (the main product page's own
    // badge, plus any pre-rendered per-variant fragments used by pickers like bundle-builder)
    // to reflect real warehouse-only stock once it arrives, instead of Shopify's native
    // available/inventory_quantity fields, which sum every location tracking the item.
    customElements.define('product-stock-alert-sync', class extends Core {
        elements = {
            configJSON: '[data-stock-alert-strings]'
        }

        subscriptions = {
            'warehouse-stock:ready': '_onStock'
        }

        render() {
            this.strings = JSON.parse(this.$configJSON.textContent);
            this.subscribe('warehouse-stock:ready', { global: true });
        }

        _onStock({ stock }) {
            if (!stock) return;
            document.querySelectorAll('.\\#product-stock-alert[data-variant-id]').forEach($el => {
                const entry = stock[$el.getAttribute('data-variant-id')];
                if (entry) this._update($el, entry);
            });
        }

        _update($el, entry) {
            let text, icon, type;
            if (!entry.available) {
                text = this.strings.outOfStock;
                icon = 'x';
                type = 'danger';
            } else if (
                this.strings.threshold && entry.quantity <= this.strings.threshold &&
                entry.managed && entry.policy === 'deny'
            ) {
                // Matches product-stock-alert.liquid: the low-stock count only makes sense
                // when overselling is denied — an oversellable ("continue" policy) variant
                // hitting 0 should read as preorder, not "0 left in stock".
                text = this.strings.lowStock.replace('__VALUE__', entry.quantity);
                icon = 'exclamation';
                type = 'warning';
            } else if (entry.quantity <= 0) {
                text = this.strings.preorder;
                icon = 'exclamation';
                type = 'warning';
            } else {
                text = this.strings.inStock.replace('__VALUE__', entry.quantity);
                icon = 'check';
                type = 'success';
            }

            const $text = $el.querySelector('.\\#product-stock-alert-text');
            if ($text) $text.textContent = text;

            const $status = $el.querySelector('.\\#product-stock-alert-icon-status');
            if ($status) {
                $status.className = '#product-stock-alert-icon-status text-' + type;
                const $use = $status.querySelector('use');
                if ($use) $use.setAttribute('href', '#svg-icon-' + icon);
            }
        }
    });
})();
